import { render, staticRenderFns } from "./WhatsappEventsCategoryChart.vue?vue&type=template&id=18239fa0&scoped=true&"
import script from "./WhatsappEventsCategoryChart.vue?vue&type=script&lang=js&"
export * from "./WhatsappEventsCategoryChart.vue?vue&type=script&lang=js&"
import style0 from "./WhatsappEventsCategoryChart.vue?vue&type=style&index=0&id=18239fa0&lang=scss&scoped=true&"
import style1 from "./WhatsappEventsCategoryChart.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18239fa0",
  null
  
)

export default component.exports